import { Breadcrumb } from '../../../components/Breadcrumb';
import { PageHeader } from '../../../components/PageHeader';
import { useTranslation } from '../../../contexts/translation-context';
import { DataField } from '../../../components/DataField';
import { PageHeading } from 'components/PageHeading';
import { Card } from 'components/Card';
import { formatVatNumber } from '@utils/vat-number';
import useSWR from 'swr';
import { formatPhoneNumber } from '@utils/phonenumber';
import { fetchOurContactInformation } from './models';
import { SpinnerBlock } from '../../../components/Spinner';
import { ErrorState } from '../../../components/error-state/ErrorState';

export const OurInformationPage = () => {
  const { i18n } = useTranslation();
  const { data: information, error, isLoading, mutate } = useSWR('our-contact-information', fetchOurContactInformation);

  if (isLoading) {
    return <SpinnerBlock message={i18n('customerPortal.loading')} />;
  }

  if (error || !information) {
    return <ErrorState error={error} onRetry={error ? () => mutate() : undefined} variant="section" />;
  }

  return (
    <div>
      <PageHeader title={i18n('customerPortal.ourInformation.ourInformation')} />

      <PageHeading
        noMarginBottom
        leftSide={<Breadcrumb currentItem={i18n('customerPortal.ourInformation.ourInformation')} />}
      />

      <div className="grid gap-4 p-7">
        <div className="card flex flex-col gap-4 p-5">
          <DataField title={i18n('customerPortal.ourInformation.name')}>{information.name}</DataField>

          <div className="grid grid-cols-2 gap-4">
            <DataField title={i18n('customerPortal.ourInformation.vatNumber')}>
              {formatVatNumber(information.vatNumber)}
            </DataField>
            <DataField title={i18n('customerPortal.ourInformation.businessNumber')}>
              {information.companyNumber}
            </DataField>
          </div>

          <DataField
            title={i18n('customerPortal.ourInformation.address')}
          >{`${information.street} ${information.streetNumber}, ${information.postalCode} ${information.city}, ${information.country}`}</DataField>
        </div>

        <Card title={i18n('customerPortal.ourInformation.contact')}>
          <div className="grid grid-cols-2 gap-4">
            <DataField title={i18n('customerPortal.ourInformation.phoneNumber')}>
              {formatPhoneNumber(information.phoneNumber)}
            </DataField>
            <DataField title={i18n('customerPortal.ourInformation.emailTransport')}>
              {information.emailTransport}
            </DataField>
            <DataField title={i18n('customerPortal.ourInformation.emailAccounting')}>
              {information.emailAccounting}
            </DataField>
            <DataField title={i18n('customerPortal.ourInformation.emailGeneral')}>{information.emailGeneral}</DataField>
          </div>
        </Card>
      </div>
    </div>
  );
};
